//
// # Connection enums
//

export enum ConnKind {
  Signal = "Signal",
  Slice = "Slice",
  Concat = "Concat",
  Repeat = "Repeat",
}

// # Signal Usage
export enum SignalUsage {
  Signal = "Signal",
  Power = "Power",
  Ground = "Ground",
  Clock = "Clock",
  Other = "Other",
}
